import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t,r)}const n=(e,t)=>e.map(t),r=e=>(t,n,r)=>({done:!1,hasNext:!0,next:e(t,n,r)});export{t as map};
//# sourceMappingURL=map-B5GAXxCK.js.map